import Vue from 'vue'
import ip from 'ip';
import axios from 'axios'

const baseURL = process.env.VUE_APP_API_BASE_URL

const api = axios.create({
  baseURL
})

api.interceptors.response.use(function (response) {
  return response;
}, async function (error) {
  
  if (error.response.status == 401) {
    await localStorage.removeItem('userToken');
    const label = await localStorage.getItem('label');
    window.location.replace(`${window.location.origin}/${label}`)
  }
  return Promise.reject(error);
})

api.interceptors.request.use(async config => {
  if (
      !config.url.endsWith('login') ||
      !config.url.endsWith('register') ||
      !config.url.endsWith('forgot-password')
    ) {
    const token = await localStorage.getItem('userToken')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
  }

  const clientIP = ip.address();
  config.headers['X-Forwarded-For'] = clientIP;

  return config
}, error => {
  return Promise.reject(error)
})

Vue.prototype.$http = api

export default api
